import { connect } from 'react-redux'
import * as action from '../state/action'
import * as selector from '../state/selector'
import RefinementReasonWidget from './RefinementReasonWidget'

const mapStateToProps = (state) => {
    return {
        refinementReason: selector.selectRefinementReason(state),
    }
}

const mapDispatchToProps = {
    changeRefinementReason: action.changeRefinementReason,
    saveRefinementReason: action.saveRefinementReason,
    getRefinementReason: action.getRefinementReason
}

export default connect(mapStateToProps, mapDispatchToProps)(RefinementReasonWidget)



// WEBPACK FOOTER //
// ./src/modules/refinement/component/RefinementReasonWidgetContainer.js